module.exports = __webpack_public_path__ + "img/map-button.7efa7302.svg";